// Ambient Layer — directory barrel
// Default export: the composed AmbientLayer (mount at App root).
// Named exports: the individual VhsOverlay / BootEye pieces (cursor is CSS-only:
// import "./cursor.css" and add .ambu-cursor / .industrial-cursor to a host element).
import AmbientLayer from "./AmbientLayer";
import VhsOverlay from "./VhsOverlay";
import BootEye from "./BootEye";

export { VhsOverlay, BootEye };
export default AmbientLayer;
